import { dispatcher } from "@quest/base-core";
import { ButtonController } from "@quest/murka-games-behavior-panther/dist";
import { eventDispatchers } from "../Constants/EventDispatchers";

/**
 * ButtonControllerGame class handles the  console panel of the base game and its buttons.
 */
export class ButtonControllerGame extends ButtonController {
  /**
   * Override to update Jackpot Meters Values
   */
  protected onChangeStake(value: number): void {
    super.onChangeStake(value);
    dispatcher.fireEvent(eventDispatchers.UPDATE_JACKPOT_METERS_VALUES);
  }

}
